export default __webpack_public_path__ + "static/media/s1.3f55a4b1.png";